import { rateLineProposalListQuerySchema, type RateLineProposalListQuery } from '@chukua/common';
import { useListQuery } from '../../../../../shared/hooks/use-list-query';
import { usePagedList } from '../../../../../shared/hooks/use-paged-list';
import { listApprovalQueue } from '../../../rate-cards.api';

/** The queue is whatever is pending, on every card; `status` is not the user's to change, so it is not in the URL. */
const loadPending = (query: RateLineProposalListQuery) => listApprovalQueue({ ...query, status: ['pending_approval'] });

export function useApprovalQueue() {
  const list = useListQuery(rateLineProposalListQuerySchema);
  return { list, ...usePagedList(list.query, loadPending) };
}
